import React from "react";
import { useNavigate } from "react-router-dom";
import { PageHero, Section, Eyebrow } from "@/components/PageParts";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useSettings } from "@/context/SettingsContext";
import { CheckCircle2, Wand2 } from "lucide-react";

const INCLUDES = [
  "Business blueprint", "90-day launch plan", "Provider acquisition system", "Family acquisition system",
  "Referral-source system", "CRM", "AI workflows", "Automation templates", "Intake workflows",
  "Email sequences", "Call scripts", "Provider recruitment materials", "Content engine", "KPI dashboard",
  "Operating SOPs", "Business-launch wizard",
];

export default function BusinessInABox() {
  const nav = useNavigate();
  const settings = useSettings();
  return (
    <div>
      <PageHero eyebrow="Business-in-a-Box Accelerator" title="The $50 membership teaches the business. The Accelerator provides the machine."
        subtitle={`Care Placement Pro Business-in-a-Box Accelerator — ${settings.accelerator_price}. A complete operating system to launch your independent private-pay placement company.`}>
        <div className="flex flex-col gap-3 sm:flex-row">
          <Button data-testid="biab-buy-btn" size="lg" onClick={() => window.open(settings.skool_accelerator_url, "_blank")}
            className="bg-clinical hover:bg-clinical/90">
            Get the Accelerator — {settings.accelerator_price}
          </Button>
          <Button data-testid="biab-join-btn" size="lg" variant="outline" onClick={() => nav("/join")}
            className="border-white/30 bg-transparent text-white hover:bg-white/10">
            Start with membership — {settings.membership_price}
          </Button>
        </div>
      </PageHero>
      <Section className="py-20">
        <Eyebrow>What's included</Eyebrow>
        <h2 className="mt-3 font-heading text-3xl font-semibold tracking-tight text-navy">Everything to launch the machine</h2>
        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {INCLUDES.map((i) => (
            <div key={i} className="flex items-center gap-3 rounded-lg border border-slate-200 bg-white p-4" data-testid={`biab-${i}`}>
              <CheckCircle2 className="h-5 w-5 shrink-0 text-emeraldbrand" />
              <span className="text-sm font-medium text-slate-700">{i}</span>
            </div>
          ))}
        </div>
        <Card className="mt-12 grid gap-8 bg-navy p-10 text-white lg:grid-cols-2 lg:items-center">
          <div>
            <Wand2 className="h-9 w-9 text-clinical" />
            <h3 className="mt-4 font-heading text-2xl font-semibold">AI business-launch wizard</h3>
            <p className="mt-3 text-slate-300">
              Answer a few questions about your business and market. Our AI generates positioning, a 90-day plan,
              acquisition plans, a 30-day content calendar, scripts, email sequences, and daily/weekly checklists.
              Legal templates always require independent legal review.
            </p>
          </div>
          <div className="flex lg:justify-end">
            <Button data-testid="biab-wizard-btn" size="lg" onClick={() => nav("/join")} className="bg-clinical hover:bg-clinical/90">
              Available to Accelerator customers
            </Button>
          </div>
        </Card>
      </Section>
    </div>
  );
}
